/**
 * Converts term to lower case.
 */
export function lowerCaseFilter(term) {
    return term.toLowerCase();
}
var NWSTART_RE = /^\W+/;
var NWEND_RE = /\W+$/;
/**
 * Removes all non-word characters at the start and at the end of the term.
 */
export function trimNonWordCharactersFilter(term) {
    return term.replace(NWSTART_RE, "").replace(NWEND_RE, "");
}
//# sourceMappingURL=filters.js.map